// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
export const useCopyAndMoveTaskDialogStyles = makeStyles({
    dialogSurface: {
        width: "clamp(320px, 90vw, 560px)",
        backgroundColor: tokens.colorNeutralBackground1,
        color: tokens.colorNeutralForeground1
    },
    dialogTitle: {
        fontWeight: tokens.fontWeightSemibold,
        padding: "0px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    },
    dialogContent: {
        paddingTop: tokens.spacingVerticalS,
        paddingBottom: "0px"
    }
});
